import fetchPost from '@/api/http.js'

export default {
    actions: {
        queryRowInfo({}, data) {//查询明细
            return fetchPost('/saas/shipperOrderController/queryRowInfo', data)
        }, uploadTOdownDetail({}, data) {//查询明细
            return fetchPost('/saas/shipperOrderController/uploadTOdownDetail', data)
        },
        getAllFlowMoneyDetail({}, data) {//查询明细
            return fetchPost('/saas/projectAssign/flowDetail', data)
        },
    }
}
